import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import FormLoader from '../../../../components/loader/FormLoader'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../components/pagination/Pagination'
import FullLoader from '../../../../components/loader/FullLoader'

function BalanceCustomers() {
  const baseURL = (import.meta as any).env.VITE_BASE_URL
  const { notify } = useGlobalContext()
  const navigate = useNavigate()
  const [customersList, setCustomersList] = useState<any>({ data: [] })
  const [bookingsLoading, setBookingsLoading] = useState(true)
  const [search, setSearch] = useState('')

  function fetchCustomers(page: number, pageSize: number) {
    setBookingsLoading(true)
    let url = ''
    if (search) {
      url = `admin/balance-users?search=${search}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/balance-users?page=${page}&limit=${pageSize}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setCustomersList(result.data)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }

  useEffect(() => {
    fetchCustomers(1, 10)
  }, [])

  //<----------- Download Excel and CSV --------------->
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async (format: string) => {
    const token = sessionStorage.getItem('token')
    let apiUrl = `${baseURL}/admin/balance-users/export?format=${format}`

    try {
      // Make an API request to fetch the Excel file
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          // Add any necessary headers, like authorization if required
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      // Convert the response to a Blob
      const blob = await response.blob()

      // Extract the filename from the "Content-Disposition" header
      const fileName = `Customers`

      // Create a download link for the Blob
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName // Use the filename from the backend
      document.body.appendChild(a) // Append to the DOM
      a.click() // Trigger the download
      a.remove() // Clean up
      window.URL.revokeObjectURL(url) // Release memory
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }
  const selectCustomer = (id: string) => {
    navigate(`/admin/customer/${id}`)
  }

  //

  return (
    <div className='home'>
      {downloading && <FullLoader />}
      <div className='home_tables'>
        <div className='left'>
          {bookingsLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              <div className='flex justify-between items-center search-btns flex-wrap'>
                <div className='search flex flex-wrap'>
                  <input
                    type='search'
                    name=''
                    id=''
                    value={search}
                    placeholder='search by name or tracking Id or user Id'
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />{' '}
                  <button
                    onClick={() => {
                      fetchCustomers(1, 10)
                    }}
                  >
                    Search
                  </button>
                </div>
                <div className='buttons flex dif'>
                  <button onClick={() => handleDownload('csv')}>
                    Export CSV
                  </button>
                  <button onClick={() => handleDownload('excel')}>
                    Export EXCEL
                  </button>
                </div>
              </div>
              {customersList.users.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {customersList.users.map((data: any, i: number) => (
                      <div
                        className='card'
                        onClick={() => navigate(`/admin/customer/${data._id}`)}
                      >
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Full Name</h4>
                          <p>
                            {data.firstname} {data.lastname}
                          </p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Role</h4>
                          <p>{data.role}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Balance</h4>
                          <p>NGN{data.balance.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Email</h4>
                          <p>{data.email}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Full Name</th>
                        <th>Username</th>
                        <th>Balance</th>
                        <th>Role</th>
                        <th>Email</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {customersList.users.map((data: any, i: number) => (
                        <tr key={data._id}>
                          <td>{i + 1}</td>
                          <td onClick={() => selectCustomer(data._id)}>
                            {data.firstname} {data.lastname}
                          </td>
                          <td
                            onClick={() => selectCustomer(data._id)}
                            className='count'
                          >
                            {data.username}
                          </td>
                          <td className='count'>
                            NGN{data.balance.toLocaleString()}
                          </td>
                          <td className='count'>{data.role}</td>
                          <td className='count'>{data.email}</td>
                          <td className='icons dif'>
                            <span
                              className='PU'
                              onClick={() => selectCustomer(data._id)}
                            >
                              view
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    className='pagination-bar'
                    currentPage={customersList.pagination.page}
                    totalCount={customersList.pagination.totalPages}
                    pageSize={customersList.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      fetchCustomers(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='majesticons:book-line' />
                    <h1>No Customers To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default BalanceCustomers
